import React, { Component } from 'react';
import { db, COLLECTION_BOOKING_DATES_REF } from '../../firebase';
import logger from '../../services/logger';


const createInitialState = () => ({
    dates: [],
    isLoading: true,
    error: false,
});

export function withManageHolidayProvider(WrappedComponent) {
    return class extends Component {
        state = createInitialState();

        componentDidMount() {
            this.fetchHoliday();
        }

        fetchHoliday = async () => {
            const newState = createInitialState();

            this.setState({ ...newState });

            try {
                const snapshot = await db.collection(COLLECTION_BOOKING_DATES_REF)
                    .where('holiday', '==', true)
                    .get();

                if (!snapshot.empty) {
                    const dates = [];

                    snapshot.forEach(doc =>  dates.push({ id: doc.id, ...doc.data() }));

                    this.setState({ dates });
                }
            } catch (e) {
                logger.error('Error fetching holiday: ' + JSON.stringify(e));
            }

            this.setState({ error: true, isLoading: false });
        }

        render() {
            const {
                dates,
                isLoading,
                error,
            } = this.state;

            return (
                <WrappedComponent 
                    dates={dates}
                    fetchHoliday={this.fetchHoliday}
                    isLoading={isLoading}
                    error={error}
                />
            );
        }
    }
} 
